import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/confirm-delete-dialog/confirm-delete-dialog.component';


@Component({
  selector: 'app-execution-list',
  templateUrl: './execution-list.component.html',
  styleUrl: './execution-list.component.css'
})
export class ExecutionListComponent implements OnInit {
  displayedColumns: string[] = ['srNo',
    'projectName', 'projectManager',
    'startDate', 'endDate','stage', "action"
  ];


  dataSource = new MatTableDataSource([]);
  searchKeyword = "";
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(private apiService: ApiService, private toastrMsgService: ToastrMsgService,private dialog: MatDialog) {

  }



  ngOnInit(): void {

    this.fetchData();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.kycStatus.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }
  fetchData() {
    const params = { keyword: this.searchKeyword ? this.searchKeyword : "" };
    this.apiService.getProject(params).subscribe({
      next: (res: any) => {
        console.log(res);
        this.dataSource.data = res;
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  deleteProject(item: any) {
  const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
    width: '400px',
    data: { itemName: item.project_name }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
        this.apiService.deleteProject(item.project_id).subscribe({
      next: (res: any) => {
        console.log(res);
        this.toastrMsgService.success("Project deleted successfully");
        this.fetchData();
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
    }
  });
}



  getStatusColor(status: string): 'primary' | 'accent' | 'warn' {
  switch (status) {
    case 'Pre-Planning':
    case 'Planning':
      return 'primary';
    case 'Survey':
    case 'Design Revisions & Scope Adjustments':
      return 'accent';
    case 'Execution':
    case 'Closure':
      return 'warn';
    default:
      return 'primary';
  }
}



}